import clsx from 'clsx';
import { mapLabel } from 'components/CruiseSearchWidget/utils/reducers';
import { SelectedOption } from 'components/FiltersProvider/types';
import { PillButton } from 'components/buttons/PillButton/PillButton';
import { useAppContext } from 'contexts/appContext';
import { useEffect, useRef, useState } from 'react';
import { hasScroll, root } from './SelectedPills.css';

const labelWildcard = '{{label}}';

export interface SelectedPillsProps {
	selection: SelectedOption[];
	optionTestId: string;
	onOptionCrossClick: (option: SelectedOption) => void;
	rootClass?: string;
}

export const SelectedPills = ({ selection = [], optionTestId, onOptionCrossClick = () => {}, rootClass = '' }: SelectedPillsProps) => {
	const { dictionary } = useAppContext();
	const prevPillsCounter = useRef<number>(selection.length);
	const [hasHorizontalScrollbar, setHasHorizontalScrollbar] = useState(true);

	const refPills = useRef<HTMLElement>(null);

	useEffect(() => {
		if (refPills.current) {
			setHasHorizontalScrollbar(refPills.current.scrollWidth > refPills.current.clientWidth);
			if (refPills.current.childElementCount >= prevPillsCounter.current) {
				refPills.current.scrollLeft = refPills.current.scrollWidth;
			}
			prevPillsCounter.current = selection.length;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selection.length, refPills.current]);

	return (
		<span className={clsx(root, rootClass, { [hasScroll]: hasHorizontalScrollbar })} ref={refPills}>
			{selection.map((filter) => {
				const label = filter.option.formattedLabel ?? filter.option.label;

				return (
					<PillButton
						key={filter.option.code}
						testId={optionTestId.replace(labelWildcard, label)}
						label={mapLabel(label, filter.filterKey, dictionary)}
						showCross={true}
						onCrossClick={() => onOptionCrossClick(filter)}
					/>
				);
			})}
		</span>
	);
};
